import CartItemImage from './cartItemImage';

export default CartItemImage;